import React from 'react';
import { Flex } from '@maxhub/max-ui';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
}

export const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Подтвердить',
  cancelText = 'Отмена',
}) => {
  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
    }}>
      <div style={{
        backgroundColor: '#fff',
        padding: 24,
        borderRadius: 12,
        maxWidth: 400,
        width: '100%',
      }}>
        <h3 style={{ margin: '0 0 8px 0' }}>{title}</h3>
        <p style={{ margin: '0 0 16px 0', color: '#666' }}>{message}</p>
        <Flex gap={8} style={{ justifyContent: 'flex-end' }}>
          <button
            onClick={onClose}
            style={{
              padding: '8px 16px',
              cursor: 'pointer',
              backgroundColor: '#f0f0f0',
              border: 'none',
              borderRadius: 6,
            }}
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            style={{
              padding: '8px 16px',
              cursor: 'pointer',
              backgroundColor: '#007AFF',
              color: '#fff',
              border: 'none',
              borderRadius: 6,
            }}
          >
            {confirmText}
          </button>
        </Flex>
      </div>
    </div>
  );
};